module.exports = window["MaterialUI"].TableCell;